import {
    exportGoogleSheetsFulfilledConstants,
    exportGoogleSheetsPendingConstants,
    exportGoogleSheetsRejectedConstants
} from '../actions';

const initialState = {
    isLoadingSaveFolder: false,
};

export default function exportGoogleSheetsReducer(state = initialState, action) {

    switch (action.type) {
        case exportGoogleSheetsFulfilledConstants.SAVE_FOLDER_GOOGLE:
            return { ...initialState, isLoadingSaveFolder: false };
        case exportGoogleSheetsPendingConstants.SAVE_FOLDER_GOOGLE:
            return { ...initialState, isLoadingSaveFolder: true };
        case exportGoogleSheetsRejectedConstants.SAVE_FOLDER_GOOGLE:
            return { ...initialState, isLoadingSaveFolder: false };
        default:
            break;
    }
    return state;
}
